<template lang="pug">
div
    //- breadcrumb
    .p-a-sm.white.lt.box-shadow
        div.pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-product')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-product')",
                @click="submit",
            )
                v-loading(loader="save-product") Save

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Product List
                li.breadcrumb-item.active {{ product.name }}

    .padding(v-if="!onLoading('fetch-product')")
        .row
            .col-md-4
                //- general info
                .box
                    .box-header.dker
                        h3 General
                    .box-divider.m-a-0
                    .box-body
                        .form-group
                            label Name
                            input.form-control(
                                :value="product.name",
                                @input="updateProductAttr($event.target.value, 'name')",
                                required
                            )
                            span {{ errors.first('name') }}

                        .form-group
                            label Code
                            input.form-control(
                                :value="product.code",
                                @input="updateProductAttr($event.target.value, 'code')"
                            )
                        
                        .form-group
                            label Description
                            textarea.form-control(
                                rows="3",
                                :value="product.description",
                                @input="updateProductAttr($event.target.value, 'description')"
                            )

                .box
                    .box-header.dker
                        h3 Options
                    .box-divider.m-a-0
                    .box-body
                        .form-group
                            label Tags
                            multiselect(
                                @input="updateTags",
                                :value="product.tags",
                                :multiple="true",
                                :hide-selected="true",
                                :close-on-select="false",
                                :options="tagList",
                                track-by="id",
                                label="name",
                                placeholder="Select Tags",
                                select-label="",
                                deselect-label=""
                            )

            .col-md-8
                variants
                inventory
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import variants from './product-variants.vue';
import inventory from './product-inventory.vue';
import productMixin from './product-mixins';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: {
        variants,
        inventory,
    },

    mixins: [productMixin],

    computed: {
        ...mapGetters('tag', ['tagList']),
        ...mapGetters('product', ['product', 'variants']),
        ...mapGetters('outlet', ['allowedOutletList']),
        ...mapGetters('tag', ['tagList']),
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.fetchProduct(id);
            }

            this.clearAllBackEndErrorScope();
            this.errors.clear();
        },
    },

    created() {
        const id = this.$route.params.id;
        this.fetchProduct(id);

        // load outlet list
        if (!this.allowedOutletList.length) {
            this.getOutletList();
        }

        if (!this.tagList.length) {
            this.getTagList();
        }
    },

    methods: {
        ...mapActions('product', [
            'fetchProduct',
            'setProductAttribute',
            'updateProduct',
        ]),

        ...mapActions('outlet', ['getOutletList']),

        ...mapActions('tag', ['getTagList']),

        updateProductAttr(value, key) {
            this.setProductAttribute({ key, value });
        },

        updateTags(tags) {
            this.setProductAttribute({ key: 'tags', value: tags });
        },

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            const validate = await this.$validator.validate();

            if (!validate || this.onLoading('save-product')) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }

                return;
            }

            this.startLoading('save-product');
            this.clearAllBackEndErrorScope();

            this.updateProduct(this.product)
                .then(() => {
                    swal(
                        'Success',
                        'Product has successfully saved',
                        'success',
                    );

                    this.endLoading('save-product');
                })
                .catch(err => {
                    if (this.hasLaravelErrors(err)) {
                        this.processLaravelErrors(
                            this.$validator,
                            err.response,
                            true,
                        );
                    } else {
                        this.swal({
                            type: 'error',
                            text: err,
                            title: '',
                        });
                    }

                    const elem = $('input:text.has-error');
                    if (elem.length) {
                        elem[0].focus();
                    }

                    this.endLoading('save-product');
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-edit.vue